import { authStore } from '../../../global-store/subjects/auth';
import {
  autoPushNotificationsActions,
  autoPushNotificationsStore,
} from '../../../global-store/subjects/auto-push-notifications';
import { newsletterActions, newsletterStore } from '../../../global-store/subjects/newsletter/newsletter';
import { parselyCommonActions, parselyCommonStore } from '../../../global-store/subjects/parsely-common';
import {
  parselyMyLocalNewsActions,
  parselyMyLocalNewsStore,
} from '../../../global-store/subjects/parsely/my-local-news';
import { parselyMySportActions, parselyMySportStore } from '../../../global-store/subjects/parsely/my-sport';
import { parselyMyTeamActions, parselyMyTeamStore } from '../../../global-store/subjects/parsely/my-team';
import { getDerivedValues } from '../../containers/parsely/getters/get-derived-values';
import { useSubscribe } from '../../hooks/use-subscribe';

const getDataFromBlock = ({ htmlProps, widget, blockType }) =>
  htmlProps.blocks.filter((block) => block.type === widget.blockTypes[blockType])[0]?.data.logged ||
  htmlProps.blocks.filter((block) => block.type === widget.blockTypes[blockType])[0]?.data;

export const useContext = ({
  htmlProps,
  widget,
  widgetParselyMyTeam,
  widgetParselyMySport,
  widgetParselyMyLocalNews,
  widgetNewsletter,
}) => ({
  parselyCtx: {
    myTeam: {
      state: useSubscribe(parselyMyTeamStore),
      actions: parselyMyTeamActions,
      widget: widgetParselyMyTeam,
      derivedValues: getDerivedValues({
        state: useSubscribe(parselyMyTeamStore),
        htmlProps: getDataFromBlock({ htmlProps, widget, blockType: 'myTeam' }),
        widget: widgetParselyMyTeam,
        authState: useSubscribe(authStore),
        parselyCommonState: useSubscribe(parselyCommonStore),
      }),
      htmlProps: getDataFromBlock({ htmlProps, widget, blockType: 'myTeam' }),
    },
    mySport: {
      state: useSubscribe(parselyMySportStore),
      actions: parselyMySportActions,
      widget: widgetParselyMySport,
      derivedValues: getDerivedValues({
        state: useSubscribe(parselyMySportStore),
        htmlProps: getDataFromBlock({ htmlProps, widget, blockType: 'mySport' }),
        widget: widgetParselyMySport,
        authState: useSubscribe(authStore),
        parselyCommonState: useSubscribe(parselyCommonStore),
      }),
      htmlProps: getDataFromBlock({ htmlProps, widget, blockType: 'mySport' }),
    },
    myLocalNews: {
      state: useSubscribe(parselyMyLocalNewsStore),
      actions: parselyMyLocalNewsActions,
      widget: widgetParselyMyLocalNews,
      derivedValues: getDerivedValues({
        state: useSubscribe(parselyMyLocalNewsStore),
        htmlProps: getDataFromBlock({ htmlProps, widget, blockType: 'myLocalNews' }),
        widget: widgetParselyMyLocalNews,
        authState: useSubscribe(authStore),
        parselyCommonState: useSubscribe(parselyCommonStore),
      }),
      htmlProps: getDataFromBlock({ htmlProps, widget, blockType: 'myLocalNews' }),
    },
    common: {
      state: useSubscribe(parselyCommonStore),
      actions: parselyCommonActions,
    },
  },
  newslettersCtx: {
    state: useSubscribe(newsletterStore),
    actions: newsletterActions,
    widget: widgetNewsletter,
    htmlProps: getDataFromBlock({ htmlProps, widget, blockType: 'newsletters' }),
  },
  WPNCtx: {
    state: useSubscribe(autoPushNotificationsStore),
    actions: autoPushNotificationsActions,
  },
});
